module.exports = __webpack_public_path__ + "7f25efabf27f3fd82ec38a12477a4d46.png";